import QRCode from "qrcode";

/**
 * An SVG string, not a canvas: the code has to stay crisp when a phone camera is
 * held at an angle, and an inline SVG needs no second network round trip.
 */
export async function qrSvg(payload: string): Promise<string> {
  return QRCode.toString(payload, {
    type: "svg",
    margin: 1,
    errorCorrectionLevel: "M",
    color: { dark: "#33301F", light: "#F7F3E9" },
  });
}
